import React, { useEffect, useRef, useState } from 'react'
import { Container, Grid } from '@mui/material'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import DoneAllIcon from '@mui/icons-material/DoneAll';
import Tokoimg from "../../../../assets/images/tokenomics.png"
import copy from "../../../../assets/images/copy.png"

import { SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../../Styles/style'

const DivcA = styled.button`
cursor: not-allowed;
background-color:#FFF;
border-radius:15px;
display:flex;
align-items: center;
justify-content:space-between;
padding: ${(props) => (props.p ? props.p : "0PX 20px")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  border:none;
`
const Div = styled.div`
border-radius:15px;
border:1px solid #fff;
display:flex;
align-items: center;
justify-content:space-between;
padding: ${(props) => (props.p ? props.p : "10PX 20px")};
  margin: ${(props) => (props.m ? props.m : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`
const Tokoimgs = styled.img`
width:100%;
height:auto;
max-width:700px;
`

const Textarea = styled.textarea`
font-size: 20px;
resize: none;
font-family: "P-R";
overflow: hidden;
color:#fff;
border: none;
width:540px;
/* width:60px; */
height: 50px;
padding:11px;
background: transparent;
text-align: -webkit-center;
text-align: -moz-center;
outline: none;
@media screen and (max-width: 1500px) {
  width:340px;
  /* height: 70px; */
  
}
@media screen and (max-width: 1150px) {
  width:240px;
  
}
@media screen and (max-width: 899px) {
  
width:540px;
  
}
@media screen and (max-width: 750px) {
  /* height: UNSET; */
    width:UNSET;
}
`;
const ContractAdd = styled.span`
word-break: keep-all;
/* padding:30px 0 0; */
display: flex;
align-items: center;

`;
const Toko = () => {

  const theme = useTheme()
  const handleClick = () => {
    const textToCopy = '0x60C89f5eC551350235388b33d10643d46CaBE907';
    navigator.clipboard.writeText(textToCopy);
    toast.success('0x60C89f5eC551350235388b33d10643d46CaBE907');
  };
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess(<DoneAllIcon style={{ fill: "#fff" }} />);
  }
  useEffect(() => {
    setTimeout(() => {
      setCopySuccess('')
    }, 2000)
  }, [copySuccess]);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const handleClickDis = () => {
    setButtonDisabled(true);
  };
  return (
    <div>

      <ToastContainer />
      <SectionWrapper p="6rem 0" id='Stats'>
        <Container maxWidth="xl">
          <SectionSubHeading p="80px 0" data-aos="flip-up" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="600" data-aos-offset="0">
            Floki Statistics
          </SectionSubHeading>
          <Grid container spacing={6} style={{ alignItems: 'start' }}>
            <Grid item xs={12} md={6} data-aos="fade-right" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="500">
              <Tokoimgs loading="lazy"  src={Tokoimg} />
            </Grid>
            <Grid item xs={12} md={6} data-aos="fade-left" data-aos-easing="ease-in"data-aos-delay="400"data-aos-duration="500">
              <SectionSmallHeading p="0px 0 10px" m="0" maxWidth="70%" fs="32px" fs600px="14px">Built On Pulsechain</SectionSmallHeading>
              <Div p="0px 0 0 20px">
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">Contract</SectionSmallHeading>
                <ContractAdd onClick={handleClick}>
                  <Textarea ref={textAreaRef} value="0x60C89f5eC551350235388b33d10643d46CaBE907" />
                  <img
                    onClick={copyToClipboard}
                    style={{ cursor: "pointer" }}
                    src={copy}
                  />
                  {/* {copySuccess} */}
                </ContractAdd>
              </Div>
              <SectionSmallHeading p="10px 0" m="0" maxWidth="70%" fs="32px" fs600px="14px">Tokeomics</SectionSmallHeading>
              <Div>
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">Symbol</SectionSmallHeading>
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">FLOKI</SectionSmallHeading>
              </Div>
              <Div>
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">Taxes</SectionSmallHeading>
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">5/5</SectionSmallHeading>
              </Div>
              <Div p="0px 0 0 20px">
                <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">Liquidity</SectionSmallHeading>
                <DivcA p="10px 30px" onClick={handleClickDis} disabled={isButtonDisabled}>
                  <SectionSmallHeading color={theme.textSecondary} p="0px 0" m="0" maxWidth="70%" fs600px="14px">Locked</SectionSmallHeading>
                </DivcA>
              </Div>
            </Grid>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  )
}

export default Toko
